import axios from 'axios'
import { getUserToken } from './commonFunction';
// const apiEndPoint = "https://globaldevapi.dahrb2b.com/api";
const apiEndPoint = process.env.client_apiEndpoint;
const wordpressApiEndPoint = process.env.wordpressApiEndPoint;
const excursionApiEndPoint = process.env.excursionApiEndPoint;
const service = axios.create({
    headers: {}
});
const handleSuccess = (response) => {
    return response;
};

const handleError = (error) => {
    return Promise.reject(error);
};
service.interceptors.response.use(handleSuccess, handleError);

export const ApiCall = async (method, path, payload, header, type) => {
    try {
        let baseURLToConsider = type ? wordpressApiEndPoint : apiEndPoint;
        if (type === 'excursion') {
            baseURLToConsider = excursionApiEndPoint;
        }
        if (!header?.["authorization"]) {
            if (!header) {
                header = {};
            }
            header["authorization"] = getUserToken();
        }
        return await service.request({
            method,
            url: (baseURLToConsider) + path,
            responseType: (payload?.responseType === 'blob') ? "blob" : 'json',
            data: payload,
            headers: header
        });
    } catch (error) {
        console.log('axiosApiCall-----==', error);
        if (error.message === 'Network Error') {
            console.log(`${error}, Server is not responding, please try again after some time`);
        }
        if (error.response?.data?.statusCode === 401) {
            return error.response;
        } else {
            return error.response;
        }
    }
};

export const ExcursionApiCall = async (method, path, payload, header, type) => {
    try {
        let baseURLToConsider = type ? wordpressApiEndPoint : apiEndPoint;

        if (!header?.["authorization"]) {
            if (!header) {
                header = {};
            }
            header["authorization"] = getUserToken();
        }
        return await service.request({
            method,
            url: (baseURLToConsider) + path,
            responseType: (payload?.responseType === 'blob') ? "blob" : 'json',
            data: payload,
            headers: header
        });
    } catch (error) {
        console.log('axiosApiCall-----==', error);
        if (error.message === 'Network Error') {
            console.log(`${error}, Server is not responding, please try again after some time`);
        }
        if (error.response?.data?.statusCode === 401) {
            return error.response;
        } else {
            return error.response;
        }
    }
};

export const GetApiCall = async (method, path, header, type) => {
    try {
        return await service.request({
            method,
            url: (type ? wordpressApiEndPoint : apiEndPoint) + path,
            responseType: 'json',
            headers: header
        });
    } catch (error) {
        console.log('axios---getapicall--==', error);
        if (error.message === 'Network Error') {
            console.log(`${error}, Server is not responding, please try again after some time`);
        }
        if (error.response?.data?.statusCode === 401) {
            return error.response;

        } else {
            return error.response;
        }
    }
};
